import React from 'react';

import type { ReportList } from 'api/endPoints/getReportList';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { NavIconWithTooltip } from 'components/common/NavIconWithTooltip/NavIconWithTooltip';
import classes from 'components/common/reportingSideMenu/components/MenuGroupItems/MenuGroupItems.module.scss';

interface Props {
    items: ReportList[];
    selectedItemId: string;
    handleItemClick: (item: ReportList) => void;
}

export const MenuGroupItems = ({ items, selectedItemId, handleItemClick }: Props) => {
    return (
        <div className={classes.itemsWrapper}>
            {items.map((item) => (
                <NavIconWithTooltip
                    tooltipContent={item.name}
                    showTooltip={true}
                    tooltipPosition={TooltipPosition.Bottom}
                    key={item.id}
                >
                    <div
                        className={`${classes.item} ${selectedItemId === item.id.toString() && classes.selected}`}
                        onClick={() => handleItemClick(item)}
                    >
                        <span className={classes.itemText}> {item.name}</span>
                    </div>
                </NavIconWithTooltip>
            ))}
        </div>
    );
};
